import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_DENSITY, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { Range } from "../../../range/range";
import { setDensity } from "../../../../features/config/config.slice";
export const SnowflakeDensity = ({ index, layer }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Density", tooltip: "The amount of snowflakes to draw", showOutput: true, reset: () => {
            const density = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].density : DEFAULT_DENSITY;
            dispatch(setDensity({
                index,
                density
            }));
        }, value: layer.density || 0, onChange: (event) => {
            dispatch(setDensity({
                index,
                density: Number(event.target.value),
            }));
        }, children: _jsx(Range, { min: "0", max: "1000", step: "1" }) }));
};
